import { Button, Modal, useLoading } from "best-common-react";
import React from "react";
import { revokeDayOfRequest } from "../../../api/RequesTixApi";

type AdminTicketsRevokeModalProps = {
  isOpen: boolean;
  onClose: () => void;
  requestId: number;
};

const AdminTicketsRevokeModal: React.FC<AdminTicketsRevokeModalProps> = ({ isOpen, onClose, requestId }) => {
  const { setLoading } = useLoading();

  const revokeTicketsCall = async () => {
    try {
      setLoading(true);
      await revokeDayOfRequest(requestId);
      onClose();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={isOpen} size="lg">
      <Modal.Header>Are you sure you want to revoke these tickets</Modal.Header>
      <Modal.Body>
        <div>Please confirm you wish to send a revoke these tickets</div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" disabled={false} onClick={revokeTicketsCall}>
          Revoke
        </Button>
        <Button variant="default" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdminTicketsRevokeModal;
